import React, { useEffect, useState } from 'react'
import classes from './Duty.module.css'
import { useDutyStore } from '../../store/dutyStore'
import { Grid, Flex, Button, Select, Text } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import DutyTable from '../../components/DutyTable/DutyTable'
import { useGlobalStore } from '../../store/globalStore'
import UmSpinner from '../../components/UI/UmSpinner'
import DutyTableRows from '../../components/DutyTableRows/DutyTableRows'
import { classesList } from '../../utils/constants'

function Duty() {
    const user = useGlobalStore(state => state.user)
    const [week, incWeek, decWeek] = useDutyStore(state => [state.week, state.incWeek, state.decWeek])
    const [duty, fetchDuty] = useDutyStore(state => [state.duty, state.fetchDuty])
    const [disabledBtns, setDisabledBtns] = useState({
        prev: week > 0,
        next: week < duty?.weeks?.length
    })
    const [classId, setClassId] = useState(1)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        async function fetching() {
            setIsLoading(true)
            await fetchDuty(user.subject_id, classId)
            setIsLoading(false)
        }

        fetching()
    }, [user])

    const onClassChange = async (event) => {
        setIsLoading(true)
        const newClassId = Number(event.target.value)
        setClassId(newClassId)
        await fetchDuty(user.subject_id, newClassId, true)
        setIsLoading(false)
    }

    const onPrevWeek = () => {
        if (week > 0 && week < duty?.weeks?.length)
            decWeek()
        setDisabledBtns({ prev: week - 1 === 0, next: week - 1 >= duty?.weeks?.length })
    }

    const onNextWeek = () => {
        if (week + 1 < duty?.weeks?.length)
            incWeek()
        setDisabledBtns({ prev: week + 1 === 0, next: week + 2 >= duty?.weeks?.length })
    }

    const classesSelect = () => {
        if ([1, 3].includes(user?.subject_id)) {
            return classesList.map((classObj) => (
                <option
                    value={classObj.id}
                    key={`class${classObj.id}`}
                >
                    {classObj.title}
                </option>
            ))
        }
        else {
            return (
                <option
                    value={classesList[1].id}
                    key={`class${classesList[1].id}`}
                >
                    {classesList[1].title}
                </option>
            )
        }
    }

    return (
        <Grid className={classes.container}>
            <Grid
                className={classes.manage}
                style={isLoading ? {pointerEvents: "none", opacity: "0.5"} : {}}
            >
                <Flex gap='calc(var(--default-gap) / 2)'>
                    <Text>Класс:</Text>
                    <Select
                        value={classId}
                        onChange={onClassChange}
                        maxW='200px'
                    >
                        {classesSelect()}
                    </Select>
                </Flex>
                <Flex gap='var(--default-gap)' alignItems='center'>
                    <Button
                        leftIcon={<ChevronLeftIcon />}
                        onClick={onPrevWeek}
                        isDisabled={disabledBtns.prev}
                    >
                        Предыдущая неделя
                    </Button>
                    <Button
                        rightIcon={<ChevronRightIcon />}
                        onClick={onNextWeek}
                        isDisabled={disabledBtns.next}
                    >
                        Следующая неделя
                    </Button>
                </Flex>
            </Grid>
            {
            isLoading
            ?
            <UmSpinner />
            :
            <DutyTableRows week={week} />
            }
        </Grid>
    )
}

export default Duty
